export default `
    <span class="text-span-container #= data.containerClasses || "" # #= data.bsc || "" #">
        <span
             id="#= data.id || "" #"
             class="bind-value #: data.classes || "" #"
            # if (data.bindValue) { # data-bind="#= data.fullBindValue #" # } #
            # if (data.toolTip) { # title="#= data.toolTip #" # } #>
        </span>
    </span>
`;
